import { StateCreator } from 'zustand';
import {
  IKioskDashboardControlFields,
  IKioskDashboardControlSlice,
  TKioskStore,
} from './type';

const initState: IKioskDashboardControlFields = {
  blockDashboardButtonsAvailability: false,
  blockDashboardButtonsSession: false,
};

/**
 * This is temporary solution to control dashboard buttons disable state
 * If appointment is in 15 mins or in progress - flag is up and dashboard buttons
 * are blocked
 * If kiosk schedule says that kiosk will be unavailable in 15 mins - flag is up and dashboard buttons
 * are blocked
 * @param set - The Zustand set function to update the state.
 * @returns An object containing the block state and the function to update it.
 */
export const kioskDashboardControlSlice: StateCreator<
  TKioskStore,
  [],
  [],
  IKioskDashboardControlSlice
> = (set) => ({
  ...initState,
  setBlockDashboardButtonsAvailability: (blockDashboardButtonsAvailability) =>
    set({ blockDashboardButtonsAvailability }),
  setBlockDashboardButtonsSession: (blockDashboardButtonsSession) =>
    set({ blockDashboardButtonsSession }),
});
